import L from 'leaflet'
import { CameraMapStatus } from './camera-map-status'

/**
 * Leaflet's default marker image (marker-icon.png) breaks under most
 * bundlers unless you manually rewire its asset URLs — a well-known
 * papercut. A colored divIcon sidesteps it entirely and doubles as the
 * status indicator (color = status), so we don't need a separate legend
 * icon either.
 */
const STATUS_COLORS: Record<CameraMapStatus, string> = {
  healthy: '#10b981',
  silent: '#f59e0b',
  'never-detected': '#64748b',
  inactive: '#475569',
  unknown: '#64748b',
}

const cache = new Map<CameraMapStatus, L.DivIcon>()

export const statusDivIcon = (status: CameraMapStatus): L.DivIcon => {
  const cached = cache.get(status)
  if (cached) {
    return cached
  }

  const color = STATUS_COLORS[status]

  const icon = L.divIcon({
    className: 'camera-map-marker',
    html: `<span class="camera-map-marker__dot" style="background:${color}"></span>`,
    iconSize: [22, 22],
    iconAnchor: [11, 11],
    popupAnchor: [0, -11],
  })

  cache.set(status, icon)
  return icon
}
